import React from 'react';
import { useEffect } from 'react';
import currency from 'currency.js';
import { useDispatch, useSelector } from 'react-redux';

import { formatTransactiontDate } from '../../../../helpers/date/date';
import { fetchReversedUserWithdrawalStart } from '../../../../store/actions/WithDrawAction';
import { getStatusColor } from '../../PerformerStatements/IncomeStatement';
import './styles/cards.css';
import NothingHere from '../../../../images_new/icon/nothing_here.svg?react';
import { statementStatuses } from '../../../../helpers/constants/statementStatuses';

const reversalStatuses = {
  1: 'Reverted',
  2: 'Failed',
};

export default function ReversedUserWithdrawalCards() {
  const dispatch = useDispatch();
  const reversedUserWithdrawals = useSelector((state) => state.withDraw.reversedUserWithdrawals);

  useEffect(() => {
    dispatch(fetchReversedUserWithdrawalStart());
  }, []);

  return (
    <>
      <div className={`cards-container last-card-margin`}>
        {reversedUserWithdrawals?.data?.length ? (
          reversedUserWithdrawals?.data?.map((transaction, index) => (
            <div className={`statement-card ${index % 2 !== 0 ? 'bg-white' : ''}`}>
              <div className='statement-card-header'>
                <h1
                  className='statement-card-title'
                  dangerouslySetInnerHTML={{ __html: transaction.message }}
                ></h1>
              </div>
              <div className='statement-card-body'>
                <div className='w-100 d-flex justify-content-between'>
                  <p className='statement-text-title'>Reversed on</p>{' '}
                  <p className='statement-text-data'>
                    {formatTransactiontDate(transaction.created_at)}
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between'>
                  <p className='statement-text-title'>Status</p>{' '}
                  <p
                    className={`statement-text-data hidden-xs status-text status-text-${getStatusColor(
                      reversalStatuses[transaction?.status],
                    )}`}
                  >
                    {reversalStatuses[transaction?.status]}
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between'>
                  <p className='statement-text-title'>Withdrawal Status</p>{' '}
                  <p
                    className={`statement-text-data hidden-xs status-text status-text-${getStatusColor(
                      statementStatuses[transaction?.user_withdrawal?.status],
                    )}`}
                  >
                    {statementStatuses[transaction?.user_withdrawal?.status]}
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between mt-1'>
                  <p className='statement-text-title'>Amount</p>{' '}
                  <p className='statement-text-data'>
                    {currency(transaction?.user_withdrawal?.requested_amount || 0).format()}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <>
            <div className='d-flex w-100 justify-content-center mt-3'>
              <NothingHere />
            </div>
          </>
        )}
      </div>
    </>
  );
}
